export default __webpack_public_path__ + "static/media/three-dots-vertical.3bf2eebf.svg";